import React from 'react';
import SesMissions from '../components/SesMissions';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <SesMissions />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
